"use client"

import React, { useEffect } from "react"
import { usePathname } from "next/navigation"
import {
  House,
  LayoutDashboard,
  LogIn,
  LogOut,
  NotebookPen,
  Store,
} from "lucide-react"

import { joinPaths } from "@/lib/path"
import { useHeader } from "@/components/supervvisor/header-nav/header-context"

type HeaderSetterProps = {
  children: React.ReactNode
  basePath: string
}

export function HeaderSetter({ children }: HeaderSetterProps) {
  const { setItems, setActivePath, setTitle } = useHeader()
  const pathname = usePathname()

  useEffect(() => {
    const items = [
      {
        label: "Home",
        href: "/home",
        icon: House,
      },
      {
        label: "Products",
        href: "/products",
        icon: Store,
      },
      {
        label: "Login",
        href: "/api/auth/login",
        icon: LogIn,
      },
      {
        label: "Sign Up",
        href: "/join",
        icon: NotebookPen,
      },
      {
        label: "Dashboard",
        href: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        label: "Logout",
        href: "/api/auth/logout",
        icon: LogOut,
      },
    ]
    setItems(items)
  }, [setItems])

  // since our "home" apps like dashboard, settings, and marketplace have
  // individual paths but share the same sidebar menu, we have to hack around
  // the active path to ensure the correct menu item is highlighted, hard
  // coding the dashboard menu item to be active in this context.
  useEffect(() => {
    setActivePath("/products")
  }, [pathname, setActivePath])

  return <>{children}</>
}
